@if (!isLoading && protocolProductAttributeData?.tabs?.[0]?.groups) {
<p-dialog [header]="header" [(visible)]="showAddProtocolProductDialog" (onHide)="onHide()" [style]="{ width: '60rem' }" [modal]="true">
  <div class="add-protocol-product">
    <app-mi-form [attributeLabels]="attributeLabels" [attributeValues]="attributeValues" [moduleName]="moduleName"
      [groups]="protocolProductAttributeData.tabs[0].groups" (saveData)="onSaveProtocolProduct($event)"
      (previousClick)="onPreviousClick()" [showImg]="true" [isMultipleFilesUpload]="false"
      [submitBtnText]="nextBtnLabel" [previousBtnText]="previousBtnLabel" [activeIndex]="activeIndex"
      saveBtnId="protocolProductSaveBtnId" [showCancelButton]="true" (onCancel)="onCancel()"></app-mi-form>
  </div>
</p-dialog>

} @else {
<div class="loading-spinner">
  <p-progressSpinner></p-progressSpinner>
</div>
}